export const initHeaderNavigation = (): void => {
  document.querySelectorAll<HTMLElement>('[data-site-header-navigation]').forEach((header) => {
    const navigation = header.querySelector<HTMLElement>('[data-header-navigation]');
    const toggle = header.querySelector<HTMLButtonElement>('[data-header-navigation-toggle]');

    if (!navigation || !toggle) {
      return;
    }

    const mobileLayout = window.matchMedia('(max-width: 860px)');
    let collapsed = false;

    const closeMenu = (): void => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Navigation oeffnen');
      navigation.hidden = collapsed;
    };

    const updateLayout = (): void => {
      header.classList.remove('is-collapsed', 'is-navigation-open');
      navigation.hidden = false;
      toggle.hidden = true;

      collapsed = mobileLayout.matches;

      if (collapsed) {
        header.classList.add('is-collapsed');
        toggle.hidden = false;
      }

      closeMenu();
    };

    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', willOpen ? 'Navigation schliessen' : 'Navigation oeffnen');
      header.classList.toggle('is-navigation-open', willOpen);
      navigation.hidden = !willOpen;
    });

    navigation.addEventListener('click', (event) => {
      if (collapsed && event.target instanceof HTMLAnchorElement) {
        header.classList.remove('is-navigation-open');
        closeMenu();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (collapsed && event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        header.classList.remove('is-navigation-open');
        closeMenu();
        toggle.focus();
      }
    });

    let animationFrame = 0;
    const requestLayoutUpdate = (): void => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateLayout);
    };

    window.addEventListener('resize', requestLayoutUpdate);
    mobileLayout.addEventListener('change', requestLayoutUpdate);

    if ('ResizeObserver' in window) {
      let previousWidth = header.clientWidth;
      new ResizeObserver(() => {
        const width = header.clientWidth;
        if (width !== previousWidth) {
          previousWidth = width;
          requestLayoutUpdate();
        }
      }).observe(header);
    }

    header.querySelectorAll<HTMLImageElement>('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', requestLayoutUpdate, { once: true });
      }
    });

    void document.fonts?.ready.then(requestLayoutUpdate);
    updateLayout();
  });
};
